import React, {useMemo, useState} from 'react';
import {Carousel} from "react-bootstrap";
import {Icon} from "../../components/Icons";
import {FullscreenImageView} from "../../components/FullscreenImageView";
import {getActiveLanguage} from "../../Translate";

interface ImageCarrouselProps {
    images: { url: string, fullSizeUrl?: string, legend?: { [key: string]: string } }[];
}

export default function ImageCarrouselNew(props: ImageCarrouselProps) {
    const {images} = props;

    const [activeIndex, setActiveIndex] = useState(0);
    const [fullscreenOpen, setFullscreenOpen] = useState(false);

    const totalItems = images.length;
    const currentUrl = images[activeIndex].url;
    const legenda = (images[activeIndex]?.legend || {})[getActiveLanguage()] || '';



    const handlePrev = () => {
        setActiveIndex((activeIndex - 1 + totalItems) % totalItems);
    };

    const handleNext = () => {
        setActiveIndex((activeIndex + 1) % totalItems);
    };

    const handleClicked = () => setFullscreenOpen(true);
    const handleClickedFullscreenClose = () => setFullscreenOpen(false);




    return (
        <>
            <Carousel
                interval={null}
                indicators={false}
                controls={false}
                activeIndex={activeIndex}
                onSelect={(selectedIndex) => setActiveIndex(selectedIndex)}
                style={{height: '400px'}}
                onClick={handleClicked}
            >

                {/* Remaining items: Images */}
                {images.map((image, index) => (
                    <Carousel.Item key={index}>
                        <div style={{
                            height: '400px',
                            width: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '1em',
                        }}>
                            <img
                                src={image.url || ''}
                                alt={`Photo ${index + 1}`}
                                style={{
                                    maxHeight: "100%",
                                    maxWidth: '100%',
                                    width: '100%',
                                    height: 'auto',
                                    aspectRatio: '16/9',
                                    objectFit: 'cover',
                                }}
                            />
                        </div>
                    </Carousel.Item>
                ))}
            </Carousel>

            <div style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                marginTop: '10px'
            }}>
                {/* Previous button */}
                <div
                    onClick={handlePrev}
                    style={{
                        fontSize: '32px',
                        cursor: 'pointer',
                        paddingLeft: '1rem',
                        paddingRight: '1rem'
                    }}
                >
                    <i className={Icon.ChevronLeftLight}/>
                </div>

                {/* Dot indicators */}
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    {Array.from({length: totalItems}).map((_, index) => (
                        <div
                            key={index}
                            onClick={() => setActiveIndex(index)}
                            style={{
                                width: '10px',
                                height: '10px',
                                border: '1px solid white',
                                borderRadius: '5px',
                                margin: '5px',
                                backgroundColor: index === activeIndex ? 'white' : 'transparent',
                                cursor: 'pointer'
                            }}
                        />
                    ))}
                </div>

                {/* Next button */}
                <div
                    onClick={handleNext}
                    style={{
                        fontSize: '32px',
                        cursor: 'pointer',
                        paddingLeft: '1rem',
                        paddingRight: '1rem'
                    }}
                >
                    <i className={Icon.ChevronRightLight}/>
                </div>
            </div>
            {fullscreenOpen && currentUrl && (
                <FullscreenImageView src={currentUrl} caption={legenda} onClick={handleClickedFullscreenClose} />
            )}
        </>


    )


}
